import React from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { Button } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";

function Description() {
  return (
    <div className="Description">
      <hr />
      {/* <br /> */}
      <h3>How the app works</h3>
      <h5>Choice of Questions</h5>
      <p>
        It's surprising how the problems we have with our hair are all so
        similar. Over time we learned that we can often provide a solution by
        asking the questions we have above instead of the long list we used to
        ask.
      </p>
      <h5>Products</h5>
      <p>
        We wanted this app to be useable world wide and accessible to everyone.
        That's why we decided to go with Amazon for the products. Amazon is also
        a well known and trusted company, we don't want to send you to a sketchy
        site. You might be able to find these products in your local hair shop
        too.
      </p>
      <p>
        The app contains affiliate links. If you click a product and decide to
        purchase, we may receive a small commission.
      </p>
      <h5>Updates</h5>
      <p>
        We have a database that is connected to an algorithm. It takes your
        answers and renders the products that we think are best for your
        problem. We check amazon for new products and any discounts that can
        help then add them to the database. It means you can use this app in the
        future and get different results. We want to improve the app so please
        feel free to give feedback.
      </p>
      {/* <h3>Share This</h3> */}
      <hr />
      <h5>Your way of helping us</h5>
      <p>
        If you find the app useful, please share it with your friends. Just
        highlight the url below, copy it then paste it wherever you like. We are
        excited to see our app help users and get feedback to make it better.
      </p>

      <TextField
        id="outlined-read-only-input"
        label="NAHC Product Selector URL"
        defaultValue="https://naturalafrohaircare.com/product-app"
        InputProps={{
          readOnly: true
        }}
        variant="outlined"
        style={{ width: "38ch" }}
      />
    </div>
  );
}

export default Description;
